import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { configureAmplify } from './amplify-config';
import { App } from './App';
import { ToastProvider } from './components/ToastProvider';
import { ReAuthProvider } from './lib/reauth';
import './styles.css';
// ADR-071 D7 / Structure Guide v6 §9 — staff-owned navbar fork. This is the
// staff COPY of navbar.css (provides the .portal-ai-* AI Providers chip styles),
// no longer the @portal-shared one. The .nxnav-* rules it also carries are inert
// here: portal-staff's AppHeader uses its own .portal-navbar markup. See
// ./components/navbar/README.md.
import './components/navbar/navbar.css';

// Configure Amplify before any render — Auth.* APIs are unusable until this runs.
configureAmplify();

const rootEl = document.getElementById('root');
if (!rootEl) {
  throw new Error('Root element #root not found in index.html');
}
createRoot(rootEl).render(
  <StrictMode>
    <BrowserRouter>
      <ToastProvider>
        <ReAuthProvider>
          <App />
        </ReAuthProvider>
      </ToastProvider>
    </BrowserRouter>
  </StrictMode>,
);
